import LandingHomePage from "../Home/LandingHomePage";

export default function LandingPage() {
  return <LandingHomePage welcome />;
}
